// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";

Vue.config.productionTip = false

/* use element-ui */
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueRouter from 'vue-router'
Vue.use(VueRouter)


import VCharts from 'v-charts'
Vue.use(VCharts)

/* use vueWaterfallEasy */
import vueWaterfallEasy from 'vue-waterfall-easy'
Vue.component('vue-waterfall-easy',vueWaterfallEasy )

/* Filter */
import * as filter from './utils/my_filter'
Object.keys(filter).forEach(key => { Vue.filter(key, filter[key])})

/* Action */
import my_action from './utils/my_action'
Vue.use(my_action)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js